import { useTranslation } from 'react-i18next';

import { MplTrans } from '@mopla/i18';

import { MplButton } from '../../../atoms/MplButton/MplButton';
import { CompleteAnim } from '../../../molecules/Animations';
import {
	EMlpIconTypes,
	EMplVariantTypes,
	MplIconMessage,
} from '../../../molecules/MplIconMessage/MplIconMessage';
import { MplModal } from '../../MplModal/MplModal';

interface ICancellationSuccessModalV2Props {
	open: boolean;
	onClose: () => void;
	hasCancellationFee: boolean;
}

export const CancellationSuccessModalV2 = ({
	open,
	onClose,
	hasCancellationFee,
}: ICancellationSuccessModalV2Props) => {
	const { t } = useTranslation('booking');

	return (
		<MplModal
			open={open}
			testId="cancellationSuccessV2-modal"
			icon={<CompleteAnim />}
			title={t('booked.cancel.success_modal.title')}
			content={
				hasCancellationFee && (
					<MplIconMessage
						type={EMlpIconTypes.Info}
						variant={EMplVariantTypes.Info}
						message={
							<MplTrans
								ns="booking"
								i18nKey="booked.cancel.success_modal.cancellation_fee_info"
							/>
						}
						dataTestid="cancellationSuccessV2-feeInfo-iconMessage"
					/>
				)
			}
			buttons={
				<MplButton
					variant="contained"
					color="primary"
					fullWidth
					onClick={onClose}
					testId="cancellationSuccessV2-navigate-button"
				>
					{t('booked.cancel.buttons.navigate_to_journey')}
				</MplButton>
			}
		/>
	);
};
